import './budget-depth-validation.scss';
var htmlContent = require('./budget-depth-validation.html');
import { BaseModalContent } from '../../shared/components/base-modal-content';
import { TranslationService } from '../../core/translation/translation';

const renderMarkup = () => htmlContent;

export class BudgetDepthValidationComponent extends BaseModalContent {
  constructor() {
    super(renderMarkup());
    this.value = null;
  }

  onCreated() {
    this.init();
  }

  init() {
    this.parentModal.container.find('#accept').click(() => this.accept());
    this.parentModal.container
      .find('.subtitle')
      .text(TranslationService.instance.translate('bd-depth-validation-content'));
  }

  accept() {
    this.value = {
      accepted: true
    };
    this.parentModal.close();
  }

  get result() {
    return this.value;
  }
}
